import { useEffect } from 'react';
import { useAppConfig, useSignInFunction, useSignOutFunction } from '..';
import { getMeControlConfig } from './builder';
import { mapMsalToMecontrol } from './util';
import { useMsal } from '@azure/msal-react';
import { chain } from 'lodash';
/**
 * update the mecontrol config when dependencies change
 */
export const useMeControlConfigEffect = (ready) => {
    var _a;
    const { accounts, instance } = useMsal();
    const { clientId, supportMsa } = useAppConfig();
    const signIn = useSignInFunction();
    const signOut = useSignOutFunction();
    const appId = clientId;
    const mcReady = (_a = window.MeControl) === null || _a === void 0 ? void 0 : _a.Loader;
    // on component mount
    useEffect(() => {
        var _a;
        if (ready && ((_a = window.MeControl) === null || _a === void 0 ? void 0 : _a.Loader)) {
            //mecontrol already exists, load it
            /** mecontrol version of the same account object */
            const accountMeControl = mapMsalToMecontrol(accounts[0]);
            const meControlConfig = getMeControlConfig({
                appId,
                signIn,
                signOut,
                supportMsa,
                getRememberedAccounts: () => {
                    const accountList = instance.getAllAccounts();
                    const meControlAccountList = chain(accountList)
                        .map(mapMsalToMecontrol)
                        .compact()
                        .value();
                    return Promise.resolve(meControlAccountList);
                },
            });
            meControlConfig.currentAccount = accountMeControl;
            window.MeControl.Loader.loadAsync(meControlConfig);
        }
        //we do not need to worry about instance/etc.  they are initialized
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [appId, ready, accounts, supportMsa, mcReady]);
};
